'use strict';

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errCode = require('err-code');

var cid = require('multiformats/cid');

var index = require('./resolvers/index.js');

var last = require('it-last');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

var toPathComponents = function toPathComponents() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (path.trim().match(/([^\\^/]|\\\/)+/g) || []).filter(Boolean);
};

var cidAndRest = function cidAndRest(path) {
  if (path instanceof Uint8Array) {
    return {
      cid: cid.CID.decode(path),
      toResolve: []
    };
  }

  var cid$1 = cid.CID.asCID(path);

  if (cid$1) {
    return {
      cid: cid$1,
      toResolve: []
    };
  }

  if (typeof path === 'string') {
    if (path.indexOf('/ipfs/') === 0) {
      path = path.substring(6);
    }

    var output = toPathComponents(path);
    return {
      cid: cid.CID.parse(output[0]),
      toResolve: output.slice(1)
    };
  }

  throw errCode__default['default'](new Error("Unknown path type ".concat(path)), 'ERR_BAD_PATH');
};

function walkPath(_x, _x2) {
  return _walkPath.apply(this, arguments);
}

function _walkPath() {
  _walkPath = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, blockstore) {
    var options,
        _cidAndRest,
        cid,
        toResolve,
        name,
        entryPath,
        startingDepth,
        result,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            _cidAndRest = cidAndRest(path), cid = _cidAndRest.cid, toResolve = _cidAndRest.toResolve;
            name = cid.toString();
            entryPath = name;
            startingDepth = toResolve.length;

          case 5:
            if (!true) {
              _context.next = 22;
              break;
            }

            _context.next = 8;
            return _awaitAsyncGenerator(index(cid, name, entryPath, toResolve, startingDepth, blockstore, options));

          case 8:
            result = _context.sent;

            if (!(!result.entry && !result.next)) {
              _context.next = 11;
              break;
            }

            throw errCode__default['default'](new Error("Could not resolve ".concat(path)), 'ERR_NOT_FOUND');

          case 11:
            if (!result.entry) {
              _context.next = 14;
              break;
            }

            _context.next = 14;
            return result.entry;

          case 14:
            if (result.next) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return");

          case 16:
            toResolve = result.next.toResolve;
            cid = result.next.cid;
            name = result.next.name;
            entryPath = result.next.path;
            _context.next = 5;
            break;

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _walkPath.apply(this, arguments);
}

function exporter(_x7, _x8) {
  return _exporter.apply(this, arguments);
}

function _exporter() {
  _exporter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path, blockstore) {
    var options,
        result,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            _context4.next = 3;
            return last__default['default'](walkPath(path, blockstore, options));

          case 3:
            result = _context4.sent;

            if (result) {
              _context4.next = 6;
              break;
            }

            throw errCode__default['default'](new Error("Could not resolve ".concat(path)), 'ERR_NOT_FOUND');

          case 6:
            return _context4.abrupt("return", result);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _exporter.apply(this, arguments);
}

function recursive(_x3, _x4) {
  return _recursive.apply(this, arguments);
}

function _recursive() {
  _recursive = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path, blockstore) {
    var options,
        node,
        _iteratorAbruptCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        child,
        recurse,
        _recurse,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _recurse = function _recurse3() {
              _recurse = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(node, options) {
                var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, file;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _iteratorAbruptCompletion2 = false;
                        _didIteratorError2 = false;
                        _context2.prev = 2;
                        _iterator2 = _asyncIterator(node.content(options));

                      case 4:
                        _context2.next = 6;
                        return _awaitAsyncGenerator(_iterator2.next());

                      case 6:
                        if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
                          _context2.next = 17;
                          break;
                        }

                        file = _step2.value;
                        _context2.next = 10;
                        return file;

                      case 10:
                        if (!(file instanceof Uint8Array)) {
                          _context2.next = 12;
                          break;
                        }

                        return _context2.abrupt("continue", 14);

                      case 12:
                        if (!(file.type === 'directory')) {
                          _context2.next = 14;
                          break;
                        }

                        return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(recurse(file, options)), _awaitAsyncGenerator), "t0", 14);

                      case 14:
                        _iteratorAbruptCompletion2 = false;
                        _context2.next = 4;
                        break;

                      case 17:
                        _context2.next = 23;
                        break;

                      case 19:
                        _context2.prev = 19;
                        _context2.t1 = _context2["catch"](2);
                        _didIteratorError2 = true;
                        _iteratorError2 = _context2.t1;

                      case 23:
                        _context2.prev = 23;
                        _context2.prev = 24;

                        if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                          _context2.next = 28;
                          break;
                        }

                        _context2.next = 28;
                        return _awaitAsyncGenerator(_iterator2.return());

                      case 28:
                        _context2.prev = 28;

                        if (!_didIteratorError2) {
                          _context2.next = 31;
                          break;
                        }

                        throw _iteratorError2;

                      case 31:
                        return _context2.finish(28);

                      case 32:
                        return _context2.finish(23);

                      case 33:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[2, 19, 23, 33], [24,, 28, 32]]);
              }));
              return _recurse.apply(this, arguments);
            };

            recurse = function _recurse2(_x5, _x6) {
              return _recurse.apply(this, arguments);
            };

            options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
            _context3.next = 5;
            return _awaitAsyncGenerator(exporter(path, blockstore, options));

          case 5:
            node = _context3.sent;

            if (node) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return");

          case 8:
            _context3.next = 10;
            return node;

          case 10:
            if (!(node.type === 'directory')) {
              _context3.next = 40;
              break;
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context3.prev = 13;
            _iterator = _asyncIterator(recurse(node, options));

          case 15:
            _context3.next = 17;
            return _awaitAsyncGenerator(_iterator.next());

          case 17:
            if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
              _context3.next = 24;
              break;
            }

            child = _step.value;
            _context3.next = 21;
            return child;

          case 21:
            _iteratorAbruptCompletion = false;
            _context3.next = 15;
            break;

          case 24:
            _context3.next = 30;
            break;

          case 26:
            _context3.prev = 26;
            _context3.t0 = _context3["catch"](13);
            _didIteratorError = true;
            _iteratorError = _context3.t0;

          case 30:
            _context3.prev = 30;
            _context3.prev = 31;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context3.next = 35;
              break;
            }

            _context3.next = 35;
            return _awaitAsyncGenerator(_iterator.return());

          case 35:
            _context3.prev = 35;

            if (!_didIteratorError) {
              _context3.next = 38;
              break;
            }

            throw _iteratorError;

          case 38:
            return _context3.finish(35);

          case 39:
            return _context3.finish(30);

          case 40:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[13, 26, 30, 40], [31,, 35, 39]]);
  }));
  return _recursive.apply(this, arguments);
}

exports.exporter = exporter;
exports.recursive = recursive;
exports.walkPath = walkPath;